module.exports = __webpack_public_path__ + "static/media/AsifAliAkber.84d4f136.jpeg";